import { Children, cloneElement, Component, isValidElement } from 'react';

import classNames from 'classnames';

import styles from './Prompt.module.css';

export class Prompt extends Component {
    renderErrorMessage() {
        const { error } = this.props;

        if (error) {
            return <div className={styles.promptError}>{error}</div>;
        } else {
            return null;
        }
    }

    renderPromptActions() {
        const { children, error } = this.props;
        const childrenList = Children.toArray(children);
        const totalButtons = childrenList.length;
        const showError = error ? error : undefined;

        return childrenList
            .filter((child) => isValidElement(child))
            .map((child, index) => {
                if (totalButtons === 1 || index === 1) {
                    return cloneElement(child, {
                        className: classNames(
                            styles.rightButton,
                            child.props.className
                        ),
                        error: showError
                    });
                }

                return cloneElement(child, {
                    className: classNames(
                        styles.leftButton,
                        child.props.className
                    )
                });
            });
    }

    render() {
        const {
            className,
            classNameActionButton,
            children,
            // Setting a confirmationMessage and showConfirmationMessage as false
            // can be useful for layout: the message will still take its space
            // even if it is not displayed
            showConfirmationMessage,
            confirmationMessage,
            // Stack buttons for mobile
            stacked
        } = this.props;
        const errorMessage = this.renderErrorMessage();
        const promptActions = this.renderPromptActions();
        const totalButtons = Children.toArray(children).filter((child) =>
            isValidElement(child)
        ).length;
        const actionButtonStyles = classNames(
            styles.actionButtons,
            totalButtons === 1 ? styles.singleAction : null
        );

        return (
            <div
                className={classNames(className, styles.Prompt, {
                    [styles.stacked]: stacked,
                    [styles.notStacked]: !stacked
                })}
            >
                {errorMessage}
                <div
                    className={classNames(
                        actionButtonStyles,
                        classNameActionButton
                    )}
                >
                    {promptActions}
                    <ConfirmationMessage
                        show={showConfirmationMessage}
                        message={confirmationMessage}
                    />
                </div>
            </div>
        );
    }
}

const ConfirmationMessage = ({ message, show }) => {
    if (message) {
        return (
            <div
                className={classNames(
                    'flex items-center pb-s text-center text-xs min-l:pb-0 min-l:text-left',
                    !show && 'hidden'
                )}
            >
                {message}
            </div>
        );
    } else return null;
};
